import {
  DefaultScreenTileInnerDivider,
  Text,
} from '~/common/components/defaultUIComponents';
import WorkingInfoApi from '~/common/api/zeiterfassungServerApi/WorkingInfoApi';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { ListView } from '~/common/components/ListView';
import { PlusSquareIcon } from '@chakra-ui/icons';
import { AddDateModal } from './AddDateModal';
import { useEmployeesContext } from './state';
import { useStore } from 'zustand';
import { DayBox } from './DayBox';
import React from 'react';

type Props = {
  employee: Employee;
};

export const EmployeeWorkingHistory: React.FC<Props> = ({ employee }) => {
  const employeeStore = useEmployeesContext();
  const { from, to } = useStore(employeeStore, (state) => ({
    from: state.dateFrom,
    to: state.dateTo,
  }));

  const { data: dates, isLoading } = WorkingInfoApi.hooks.useEmployeeDates(
    employee,
    from,
    to,
  );
  const { isOpen, onToggle } = useDisclosure();
  return (
    <>
      <Flex direction="column" w="full">
        <Box cursor="pointer" w="max-content" onClick={onToggle}>
          <Box display="inline" pr={1}>
            <PlusSquareIcon w={5} h={5} />
          </Box>
          <Text display="inline" cursor="inherit">
            working.history.bone.add.date
          </Text>
        </Box>
        <ListView
          data={dates ?? []}
          search={''}
          searchFields={() => []}
          isLoading={isLoading}
          orderBy="date"
          render={({ data: dates }) => (
            <>
              {dates.map((d) => (
                <React.Fragment key={d.id}>
                  <DefaultScreenTileInnerDivider />
                  <DayBox date={d} employee={employee} />
                </React.Fragment>
              ))}
            </>
          )}
        />
      </Flex>
      <AddDateModal isOpen={isOpen} onToggle={onToggle} employee={employee} />
    </>
  );
};
